import {
  useCallback,
  useState,
} from 'react'
import { useRouter } from 'next/router'

import { analytics } from 'utils/analytics'
import { saveUserFeedback } from 'utils/analytics/feedback'
import Email from 'components/Email'
import Feedback from 'components/Feedback'
import Rating, { RatingType } from 'components/Rating'

type RatingStep = 'feedback' | 'email'

function GuideStepRating() {
  const router = useRouter()
  const [rating, setRating] = useState<RatingType>('none')
  const [feedback, setFeedback] = useState('')
  const [email, setEmail] = useState('')
  // const [isFeedbackHidden, setIsFeedbackHidden] = useState(true)
  const [ratingStep, setRatingStep] = useState<RatingStep>()

  const rate = useCallback((rating: RatingType) => {
    setRating(rating)
    setRatingStep('feedback')

    saveUserFeedback({
      rating,
      guide: router.asPath,
      guideStep: router.query.step as string ?? undefined,
    })
    analytics.track('guide step rated', {
      rating,
      guide: router.asPath,
      guideStep: router.query.step,
    })
  }, [router])

  const sendFeedback = useCallback((e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (!feedback) return

    saveUserFeedback({
      rating,
      guide: router.asPath,
      guideStep: router.query.step as string ?? undefined,
    }, feedback)
    analytics.track('guide step feedback sent', {
      rating,
      feedback,
      guide: router.asPath,
      guideStep: router.query.step,
    })

    setRatingStep('email')
  }, [
    feedback,
    router,
    rating,
  ])

  const saveEmail = useCallback((e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (!email) return

    saveUserFeedback({
      rating,
      guide: router.asPath,
      guideStep: router.query.step as string ?? undefined,
      email,
    }, feedback)
    analytics.track('user feedback email submitted (guide step rating)', {
      rating,
      guide: router.asPath,
      guideStep: router.query.step,
      email,
    })

    setRatingStep(undefined)
    setEmail('')
    setFeedback('')
  }, [
    email,
    router,
    rating,
    feedback,
  ])

  return (
    <div className="
      relative
      flex
      items-center
      h-full
    ">
      {ratingStep === 'feedback' &&
        <Feedback
          position="top"
          title={rating === 'up' ? 'What else could we improve?' : 'What didn\'t you like?'}
          value={feedback}
          onChange={e => setFeedback(e.target.value)}
          onClickOutside={() => setRatingStep(undefined)}
          onSubmit={sendFeedback}
        />
      }
      {ratingStep === 'email' &&
        <Email
          position="top"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onClickOutside={() => setRatingStep(undefined)}
          onSubmit={saveEmail}
        />
      }
      <Rating
        ratingButtonsColor="text-gray-500"
        title="Rate this step"
        titleColor={!ratingStep ? 'text-gray-500' : 'text-gray-100'}
        value={rating}
        onRatingDownClick={() => rate('down')}
        onRatingUpClick={() => rate('up')}
      />
    </div>
  )
}

export default GuideStepRating
